/* =====================================================================
   FreakyFits Theme, seasons.js
   Alle Saison-Animationen: Partikel, Hero-Effekte, Flug in den Warenkorb.
   Respektiert „Bewegung reduzieren“ und die Einstellung „Animationen“.
   ===================================================================== */
(() => {
  'use strict';
  const FF = window.FF || {};
  const season = FF.season || document.documentElement.dataset.season;
  const level = FF.motion || 'full';
  if (level === 'off' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const FULL = level === 'full';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const rand = (a, b) => a + Math.random() * (b - a);
  const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
  const isSmall = () => window.innerWidth < 750;

  const PALETTES = {
    halloween: ['#ff7a1a', '#8dff5a', '#a56bff', '#ffe066', '#ff3b4e'],
    fasching: ['#ff3b5c', '#1e9bff', '#ffc53d', '#22c7a9', '#b86bff', '#ff8a3d'],
    kobold: ['#f5b301', '#ffd84a', '#17944a', '#2ecc71', '#ff7b39'],
    sommer: ['#ff6b35', '#00a6c9', '#ffd23f', '#ff4f9a', '#3ddc97'],
    winter: ['#ffffff', '#cfe6ff', '#9cd3ff', '#e23b4a', '#f5c451']
  };
  const colors = PALETTES[season] || PALETTES.fasching;

  /* ---------- Partikel-Engine (ein Canvas für alles) ------------------ */
  const layer = $('[data-season-fx]');
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  let W = 0, H = 0, DPR = Math.min(window.devicePixelRatio || 1, 2);
  let particles = [];
  let ambient = null;
  let running = false;
  if (layer) layer.appendChild(canvas);

  function resize() {
    W = window.innerWidth; H = window.innerHeight;
    canvas.width = W * DPR; canvas.height = H * DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize, { passive: true });

  const shapes = {
    confetti(p) { ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2); },
    dot(p) { ctx.beginPath(); ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2); ctx.fill(); },
    star(p) {
      const s = p.size / 2; ctx.beginPath();
      for (let i = 0; i < 10; i++) {
        const r = i % 2 ? s * 0.45 : s, a = (Math.PI / 5) * i - Math.PI / 2;
        ctx.lineTo(Math.cos(a) * r, Math.sin(a) * r);
      }
      ctx.closePath(); ctx.fill();
    },
    coin(p) {
      const s = p.size / 2, squash = Math.abs(Math.cos(p.rot * 2)) * 0.8 + 0.2;
      ctx.scale(squash, 1);
      ctx.fillStyle = '#e0a100'; ctx.beginPath(); ctx.arc(0, 0, s, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#ffd84a'; ctx.beginPath(); ctx.arc(0, 0, s * 0.75, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = 'rgba(255,255,255,.7)'; ctx.fillRect(-s * 0.15, -s * 0.5, s * 0.3, s);
    },
    clover(p) {
      const s = p.size / 3.2; ctx.fillStyle = p.color;
      [[-s * 0.6, -s * 0.5], [s * 0.6, -s * 0.5], [0, s * 0.55]].forEach(([x, y]) => { ctx.beginPath(); ctx.arc(x, y, s * 0.75, 0, Math.PI * 2); ctx.fill(); });
      ctx.strokeStyle = p.color; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(0, s * 0.6); ctx.quadraticCurveTo(s * 0.3, s * 1.6, -s * 0.2, s * 2); ctx.stroke();
    },
    flake(p) {
      const s = p.size / 2; ctx.strokeStyle = p.color; ctx.lineWidth = Math.max(1, s / 5); ctx.lineCap = 'round';
      for (let i = 0; i < 3; i++) { ctx.rotate(Math.PI / 3); ctx.beginPath(); ctx.moveTo(-s, 0); ctx.lineTo(s, 0); ctx.stroke(); }
    },
    bubble(p) {
      const s = p.size / 2; ctx.strokeStyle = p.color; ctx.lineWidth = 2; ctx.globalAlpha *= 0.8;
      ctx.beginPath(); ctx.arc(0, 0, s, 0, Math.PI * 2); ctx.stroke();
      ctx.fillStyle = 'rgba(255,255,255,.7)'; ctx.beginPath(); ctx.arc(-s * 0.35, -s * 0.35, s * 0.2, 0, Math.PI * 2); ctx.fill();
    },
    bat(p) {
      const s = p.size / 2, flap = Math.sin(p.age * 0.5) * 0.5 + 0.5;
      ctx.fillStyle = p.color; ctx.beginPath();
      ctx.moveTo(0, -s * 0.2);
      ctx.quadraticCurveTo(-s * 0.6, -s * (0.9 * flap + 0.1), -s * 1.4, -s * 0.2 * flap);
      ctx.quadraticCurveTo(-s * 0.9, s * 0.1, -s * 0.8, s * 0.4);
      ctx.quadraticCurveTo(-s * 0.4, s * 0.1, 0, s * 0.35);
      ctx.quadraticCurveTo(s * 0.4, s * 0.1, s * 0.8, s * 0.4);
      ctx.quadraticCurveTo(s * 0.9, s * 0.1, s * 1.4, -s * 0.2 * flap);
      ctx.quadraticCurveTo(s * 0.6, -s * (0.9 * flap + 0.1), 0, -s * 0.2);
      ctx.fill();
    },
    pumpkin(p) {
      const s = p.size / 2;
      ctx.fillStyle = '#ff7a1a';
      [-0.45, 0, 0.45].forEach((x) => { ctx.beginPath(); ctx.ellipse(x * s, 0, s * 0.55, s * 0.8, 0, 0, Math.PI * 2); ctx.fill(); });
      ctx.fillStyle = '#3b8a1e'; ctx.fillRect(-s * 0.1, -s * 1.05, s * 0.2, s * 0.35);
      ctx.fillStyle = '#1b0b00';
      ctx.beginPath(); ctx.moveTo(-s * 0.45, -s * 0.2); ctx.lineTo(-s * 0.2, -s * 0.2); ctx.lineTo(-s * 0.32, -s * 0.45); ctx.fill();
      ctx.beginPath(); ctx.moveTo(s * 0.45, -s * 0.2); ctx.lineTo(s * 0.2, -s * 0.2); ctx.lineTo(s * 0.32, -s * 0.45); ctx.fill();
      ctx.beginPath(); ctx.moveTo(-s * 0.45, s * 0.2); ctx.quadraticCurveTo(0, s * 0.6, s * 0.45, s * 0.2); ctx.quadraticCurveTo(0, s * 0.4, -s * 0.45, s * 0.2); ctx.fill();
    }
  };

  function spawn(opts) {
    particles.push(Object.assign({
      x: 0, y: 0, vx: 0, vy: 0, g: 0.18, drag: 0.985, size: 8, rot: rand(0, Math.PI * 2), vr: rand(-0.2, 0.2),
      color: pick(colors), shape: 'confetti', life: 140, age: 0, alpha: 1, wobble: 0, wobbleSpeed: rand(0.02, 0.06), fade: true
    }, opts));
    start();
  }

  function burst(x, y, count = 60, kind = null) {
    const shapesFor = {
      halloween: ['bat', 'dot', 'star', 'pumpkin'],
      fasching: ['confetti', 'confetti', 'dot', 'star'],
      kobold: ['coin', 'coin', 'clover', 'star'],
      sommer: ['dot', 'star', 'bubble', 'confetti'],
      winter: ['flake', 'flake', 'dot', 'star']
    };
    const list = kind ? [kind] : shapesFor[season] || shapesFor.fasching;
    const n = FULL ? count : Math.round(count * 0.4);
    for (let i = 0; i < n; i++) {
      const a = rand(-Math.PI * 0.95, -Math.PI * 0.05);
      const speed = rand(5, 13);
      const shape = pick(list);
      spawn({
        x, y, vx: Math.cos(a) * speed, vy: Math.sin(a) * speed, shape,
        size: shape === 'bat' ? rand(18, 28) : shape === 'coin' ? rand(12, 18) : shape === 'pumpkin' ? rand(16, 22) : rand(6, 12),
        color: shape === 'bat' ? pick(['#1a0f24', '#2b1d3d', '#000']) : pick(colors),
        g: shape === 'bat' ? 0.05 : shape === 'flake' ? 0.08 : 0.22,
        life: rand(90, 150)
      });
    }
  }
  FF.burst = burst;

  function confettiRain(count = 140) {
    for (let i = 0; i < (FULL ? count : count * 0.35); i++) {
      spawn({
        x: rand(0, W), y: rand(-H * 0.6, -10), vx: rand(-1, 1), vy: rand(1, 3), g: 0.04, drag: 0.995,
        size: rand(6, 11), shape: pick(['confetti', 'confetti', 'dot']), life: rand(220, 320), wobble: rand(0, 6)
      });
    }
  }

  function tick() {
    ctx.clearRect(0, 0, W, H);
    // Hintergrund-Partikel (Schnee usw.)
    if (ambient) ambient();
    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      p.age++;
      p.vx *= p.drag; p.vy = p.vy * p.drag + p.g;
      p.x += p.vx + (p.wobble ? Math.sin(p.age * p.wobbleSpeed) * p.wobble * 0.15 : 0);
      p.y += p.vy; p.rot += p.vr;
      const lifeLeft = 1 - p.age / p.life;
      if (lifeLeft <= 0 || p.y > H + 60 || p.x < -80 || p.x > W + 80) { particles.splice(i, 1); continue; }
      ctx.save();
      ctx.globalAlpha = p.fade ? Math.min(1, lifeLeft * 2.5) * p.alpha : p.alpha;
      ctx.translate(p.x, p.y); ctx.rotate(p.shape === 'bat' ? Math.atan2(p.vy, p.vx) * 0.25 : p.rot);
      ctx.fillStyle = p.color;
      (shapes[p.shape] || shapes.dot)(p);
      ctx.restore();
    }
    if (particles.length || ambient) requestAnimationFrame(tick);
    else { running = false; ctx.clearRect(0, 0, W, H); }
  }
  function start() { if (!running) { running = true; requestAnimationFrame(tick); } }

  /* ---------- Hintergrund-Schnee im Winter ---------------------------- */
  function initAmbientSnow() {
    const flakes = Array.from({ length: isSmall() ? 26 : 55 }, () => ({
      x: rand(0, W), y: rand(0, H), r: rand(1.2, 3.4), vy: rand(0.35, 1.1), drift: rand(0, Math.PI * 2), a: rand(0.35, 0.85)
    }));
    ambient = () => {
      ctx.save();
      flakes.forEach((f) => {
        f.y += f.vy; f.drift += 0.01; f.x += Math.sin(f.drift) * 0.4;
        if (f.y > H + 5) { f.y = -5; f.x = rand(0, W); }
        ctx.globalAlpha = f.a; ctx.fillStyle = '#ffffff';
        ctx.shadowColor = 'rgba(47,111,223,.35)'; ctx.shadowBlur = 4;
        ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2); ctx.fill();
      });
      ctx.restore();
    };
    start();
  }

  /* ---------- Hero-Effekte ------------------------------------------- */
  const svgBat = '<svg viewBox="0 0 60 30" aria-hidden="true"><path fill="currentColor" d="M30 8c-2-4-5-5-5-5s1 3 0 5c-4-3-10-6-18-5 3 2 5 5 5 8 3-1 6 0 8 3 2-2 5-2 7 0 2-1 3-1 3-1s1 0 3 1c2-2 5-2 7 0 2-3 5-4 8-3 0-3 2-6 5-8-8-1-14 2-18 5-1-2 0-5 0-5s-3 1-5 5z"/></svg>';
  const svgBalloon = (c) => `<svg viewBox="0 0 40 70" aria-hidden="true"><path d="M20 2C10 2 3 10 3 20c0 12 10 22 17 24 7-2 17-12 17-24C37 10 30 2 20 2z" fill="${c}"/><path d="M17 44l3 5 3-5z" fill="${c}"/><path d="M20 49c-3 6 3 10 0 20" stroke="rgba(0,0,0,.35)" fill="none" stroke-width="1.2"/><ellipse cx="13" cy="14" rx="3" ry="6" fill="rgba(255,255,255,.5)" transform="rotate(-20 13 14)"/></svg>`;
  const svgClover = '<svg viewBox="0 0 40 44" aria-hidden="true"><g fill="#2ecc71" stroke="#10301f" stroke-width="2"><circle cx="12" cy="13" r="9"/><circle cx="28" cy="13" r="9"/><circle cx="20" cy="26" r="9"/></g><path d="M20 30q3 8-3 13" stroke="#10301f" stroke-width="2.5" fill="none"/></svg>';
  const svgCoin = '<svg viewBox="0 0 30 30" aria-hidden="true"><circle cx="15" cy="15" r="13" fill="#e0a100" stroke="#10301f" stroke-width="2"/><circle cx="15" cy="15" r="9" fill="#ffd84a"/><path d="M13 9h4v12h-4z" fill="rgba(255,255,255,.6)"/></svg>';
  const svgBubble = '<svg viewBox="0 0 40 40" aria-hidden="true"><circle cx="20" cy="20" r="17" fill="rgba(255,255,255,.25)" stroke="rgba(0,166,201,.6)" stroke-width="2"/><circle cx="13" cy="13" r="4" fill="rgba(255,255,255,.8)"/></svg>';
  const svgFlake = '<svg viewBox="0 0 40 40" aria-hidden="true"><g stroke="#9cd3ff" stroke-width="3" stroke-linecap="round"><path d="M20 3v34M5 11l30 18M5 29l30-18"/><path d="M20 8l-4-4M20 8l4-4M20 32l-4 4M20 32l4 4"/></g></svg>';

  function floatEl(host, html, { left, size, duration, delay, from = 'bottom', sway = 30, rotate = 20, opacity = 1 }) {
    const el = document.createElement('div');
    el.className = 'fx-float';
    el.innerHTML = html;
    el.style.left = left + '%';
    el.style.width = size + 'px';
    el.style.opacity = opacity;
    el.style[from === 'bottom' ? 'bottom' : 'top'] = '-90px';
    host.appendChild(el);
    const dir = from === 'bottom' ? -1 : 1;
    const dist = host.offsetHeight + 180;
    el.animate([
      { transform: `translate(0, 0) rotate(${-rotate}deg)` },
      { transform: `translate(${sway}px, ${dir * dist * 0.5}px) rotate(${rotate}deg)` },
      { transform: `translate(${-sway}px, ${dir * dist}px) rotate(${-rotate}deg)` }
    ], { duration, delay, iterations: Infinity, easing: 'linear' });
  }

  function initHeroFx() {
    $$('[data-hero-fx]').forEach((host) => {
      if (host._fx) return;
      host._fx = true;
      const n = FULL ? (isSmall() ? 5 : 9) : 3;
      switch (season) {
        case 'halloween': {
          const fog = document.createElement('div');
          fog.className = 'fx-fog';
          host.appendChild(fog);
          for (let i = 0; i < n; i++) {
            const bat = document.createElement('div');
            bat.className = 'fx-bat';
            bat.innerHTML = svgBat;
            const s = rand(0.6, 1.3);
            bat.style.transform = `scale(${s})`;
            bat.style.color = pick(['#06040a', '#1a0f24', '#2b1d3d']);
            host.appendChild(bat);
            const y0 = rand(5, 60), y1 = y0 + rand(-20, 20), ltr = Math.random() > 0.5;
            bat.animate([
              { left: ltr ? '-8%' : '108%', top: y0 + '%' },
              { left: '50%', top: (y0 + y1) / 2 - rand(5, 15) + '%' },
              { left: ltr ? '108%' : '-8%', top: y1 + '%' }
            ], { duration: rand(9000, 16000), delay: rand(0, 9000), iterations: Infinity, easing: 'ease-in-out' });
          }
          // Taschenlampen-Effekt: Licht folgt der Maus
          const hero = host.closest('.hero');
          if (hero && FULL && !isSmall()) {
            hero.style.setProperty('--mx', '70%'); hero.style.setProperty('--my', '40%');
            const light = document.createElement('div');
            light.style.cssText = 'position:absolute;inset:0;pointer-events:none;background:radial-gradient(260px circle at var(--mx) var(--my), rgba(255,160,70,.13), transparent 70%);';
            host.appendChild(light);
            hero.addEventListener('pointermove', (e) => {
              const r = hero.getBoundingClientRect();
              hero.style.setProperty('--mx', e.clientX - r.left + 'px');
              hero.style.setProperty('--my', e.clientY - r.top + 'px');
            });
          }
          break;
        }
        case 'fasching':
          for (let i = 0; i < n; i++) {
            floatEl(host, svgBalloon(pick(colors)), { left: rand(40, 96), size: rand(34, 58), duration: rand(11000, 17000), delay: -rand(0, 16000), sway: rand(15, 40) });
          }
          break;
        case 'kobold':
          for (let i = 0; i < n; i++) {
            const coin = Math.random() > 0.55;
            floatEl(host, coin ? svgCoin : svgClover, { left: rand(35, 96), size: coin ? rand(22, 30) : rand(28, 44), duration: rand(12000, 18000), delay: -rand(0, 18000), from: 'top', rotate: coin ? 180 : 30 });
          }
          break;
        case 'sommer':
          for (let i = 0; i < n + 2; i++) {
            floatEl(host, svgBubble, { left: rand(30, 98), size: rand(18, 48), duration: rand(9000, 15000), delay: -rand(0, 15000), sway: rand(10, 30), rotate: 0, opacity: 0.9 });
          }
          break;
        case 'winter':
          for (let i = 0; i < n + 3; i++) {
            floatEl(host, svgFlake, { left: rand(0, 100), size: rand(14, 34), duration: rand(12000, 20000), delay: -rand(0, 20000), from: 'top', rotate: 180, opacity: rand(0.5, 0.95) });
          }
          break;
      }
    });
  }

  /* ---------- Weggeklickt? Dann 3 Minuten Ruhe (gilt seitenübergreifend) */
  const SNOOZE_MS = 3 * 60 * 1000;
  const snooze = (key) => { try { localStorage.setItem('ff-snooze-' + key, String(Date.now())); } catch (e) { /* egal */ } };
  const isSnoozed = (key) => {
    try { return Date.now() - parseInt(localStorage.getItem('ff-snooze-' + key) || '0', 10) < SNOOZE_MS; } catch (e) { return false; }
  };

  /* ---------- Hänge-Figur von oben (je Saison) ------------------------- */
  const DROPPERS = {
    halloween: {
      label: 'Spinne erschrecken', say: ['Iiih! 🕷️', 'Buh! Erwischt!', 'Ich wohne hier.'], thread: 'rgba(255,255,255,.35)', size: 34, burst: 'dot',
      svg: '<svg viewBox="0 0 40 40" aria-hidden="true"><g stroke="#f4eefc" stroke-width="2" fill="none" stroke-linecap="round"><path d="M14 18l-8-6-2-6M14 21l-10-2-3 4M14 24l-8 5-1 6M26 18l8-6 2-6M26 21l10-2 3 4M26 24l8 5 1 6"/></g><ellipse cx="20" cy="22" rx="8" ry="9" fill="#1a1326" stroke="#f4eefc" stroke-width="1.5"/><circle cx="20" cy="12" r="5" fill="#1a1326" stroke="#f4eefc" stroke-width="1.5"/><circle cx="18" cy="11" r="1.4" fill="#ff3b4e"/><circle cx="22" cy="11" r="1.4" fill="#ff3b4e"/></svg>'
    },
    fasching: {
      label: 'Discokugel anstupsen', say: ['Helau! 🎉', 'Alaaf! 🪩', 'Party!'], thread: 'rgba(29,26,46,.45)', size: 46, burst: null,
      svg: '<svg viewBox="0 0 48 52" aria-hidden="true"><rect x="20" y="0" width="8" height="6" rx="1.5" fill="#9aa0a6" stroke="#1d1a2e" stroke-width="2"/><circle cx="24" cy="28" r="20" fill="#d9dde3" stroke="#1d1a2e" stroke-width="2.5"/><g fill="#1e9bff"><rect x="10" y="18" width="6" height="6"/><rect x="28" y="30" width="6" height="6"/></g><g fill="#ff3b5c"><rect x="22" y="12" width="6" height="6"/><rect x="16" y="36" width="6" height="6"/></g><g fill="#ffc53d"><rect x="32" y="18" width="6" height="6"/><rect x="10" y="30" width="6" height="6"/></g><g fill="#22c7a9"><rect x="22" y="24" width="6" height="6"/></g><path d="M8 28h32M24 8v40M11 17h26M11 39h26" stroke="#1d1a2e" stroke-width=".8" opacity=".35"/><circle cx="16" cy="20" r="3" fill="#fff" opacity=".9"/></svg>'
    },
    kobold: {
      label: 'Goldmünze antippen', say: ['Glück gehabt! 🍀', 'Ein Goldtaler für dich!', 'Sláinte!'], thread: 'rgba(16,48,31,.45)', size: 40, burst: 'coin',
      svg: '<svg viewBox="0 0 40 40" aria-hidden="true"><circle cx="20" cy="22" r="16" fill="#e0a100" stroke="#10301f" stroke-width="2.5"/><circle cx="20" cy="22" r="11.5" fill="#ffd84a"/><g fill="#17944a" stroke="#10301f" stroke-width="1.2"><circle cx="16.5" cy="19" r="3.4"/><circle cx="23.5" cy="19" r="3.4"/><circle cx="20" cy="25" r="3.4"/></g><path d="M20 27q1 4-2 6" stroke="#10301f" stroke-width="1.6" fill="none"/><path d="M11 13l3 3" stroke="#fff" stroke-width="2" stroke-linecap="round" opacity=".8"/></svg>'
    },
    sommer: {
      label: 'Eis anstupsen', say: ['Erfrischend! 🍦', 'Schmilzt gleich!', 'Sommer, Sonne, Party!'], thread: 'rgba(28,36,51,.4)', size: 34, burst: 'bubble',
      svg: '<svg viewBox="0 0 34 60" aria-hidden="true"><rect x="14" y="40" width="6" height="18" rx="3" fill="#e8c9a0" stroke="#1c2433" stroke-width="2"/><path d="M5 14a12 12 0 0 1 24 0v26a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4z" fill="#ff4f9a" stroke="#1c2433" stroke-width="2.5"/><path d="M5 22h24v8H5z" fill="#ffd23f"/><path d="M5 30h24v8a2 2 0 0 1 0 0H5z" fill="#00a6c9"/><path d="M5 14a12 12 0 0 1 24 0v26a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4z" fill="none" stroke="#1c2433" stroke-width="2.5"/><path d="M10 12v8" stroke="#fff" stroke-width="2.5" stroke-linecap="round" opacity=".8"/></svg>'
    },
    winter: {
      label: 'Weihnachtskugel anstupsen', say: ['Ho ho ho! 🎄', 'Kling, Glöckchen!', 'Brrr, kalt hier!'], thread: 'rgba(19,35,61,.45)', size: 40, burst: 'flake',
      svg: '<svg viewBox="0 0 40 46" aria-hidden="true"><rect x="15" y="0" width="10" height="7" rx="2" fill="#f5c451" stroke="#13233d" stroke-width="2"/><circle cx="20" cy="26" r="17" fill="#e23b4a" stroke="#13233d" stroke-width="2.5"/><path d="M4 24q16 8 32 0" stroke="#fff" stroke-width="3" fill="none"/><g fill="#fff"><circle cx="11" cy="31" r="1.8"/><circle cx="20" cy="33" r="1.8"/><circle cx="29" cy="31" r="1.8"/></g><path d="M11 17q3-5 8-5" stroke="#fff" stroke-width="2.5" stroke-linecap="round" fill="none" opacity=".85"/></svg>'
    }
  };
  function initDropper() {
    const cfg = DROPPERS[season];
    if (!cfg || !FULL || $('.fx-spider')) return;
    const sp = document.createElement('button');
    sp.type = 'button';
    sp.className = 'fx-spider fx-dropper--' + season;
    sp.setAttribute('aria-label', cfg.label);
    sp.style.setProperty('--thread', cfg.thread);
    sp.style.width = cfg.size + 'px';
    sp.innerHTML = cfg.svg;
    document.body.appendChild(sp);
    let dropped = false;
    const onScroll = () => {
      const y = window.scrollY;
      if (isSnoozed('dropper')) return;
      if (y > 500 && !dropped) {
        dropped = true;
        sp.style.setProperty('--drop', (window.innerHeight * rand(0.22, 0.38)) + 'px');
      } else if (y < 200 && dropped) {
        dropped = false;
        sp.style.setProperty('--drop', '-90px');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    sp.addEventListener('click', () => {
      const r = sp.getBoundingClientRect();
      burst(r.left + r.width / 2, r.top + r.height / 2, 26, cfg.burst);
      sp.classList.add('is-scared');
      FF.toast && FF.toast(pick(cfg.say));
      snooze('dropper');
      setTimeout(() => { sp.classList.remove('is-scared'); dropped = false; sp.style.setProperty('--drop', '-90px'); }, 700);
    });
  }

  /* ---------- Guck-mal-Figur vom Bildschirmrand ----------------------- */
  const PEEK_SAY = {
    halloween: ['Buuuh! 👻', 'Na, schon ein Kostüm?', 'Ich hab dich gesehen …'],
    fasching: ['Helau! 🎉', 'Psst, schon verkleidet?', 'Alaaf!'],
    kobold: ['Hast du Glück? 🍀', 'Mein Gold bleibt hier!', 'Psst …'],
    sommer: ['Sommer! ☀️', 'Ab zur Party!', 'Heiß hier, oder?'],
    winter: ['Brrr! ❄️', 'Ho ho ho!', 'Schon ein Outfit für Silvester?']
  };
  function initPeeker() {
    const tpl = $('template[data-peeker]');
    if (!tpl || !FULL) return;
    let shown = 0;
    let idle;
    const show = () => {
      if (shown >= 3 || isSnoozed('peeker') || document.hidden || $('.drawer.is-open') || $('.search-modal.is-open') || $('.fx-peeker')) return;
      shown++;
      const el = document.createElement('button');
      el.type = 'button';
      el.className = 'fx-peeker';
      el.setAttribute('aria-label', 'Hallo!');
      el.style.top = rand(28, 58) + 'vh';
      el.innerHTML = `<span class="fx-peeker__bubble">${pick(PEEK_SAY[season] || ['Hallo!'])}</span><span class="fx-peeker__body">${tpl.innerHTML}</span>`;
      document.body.appendChild(el);
      requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-in')));
      const hide = () => { el.classList.remove('is-in'); el.classList.add('is-out'); setTimeout(() => el.remove(), 700); };
      const t = setTimeout(hide, 6000);
      el.addEventListener('click', () => {
        clearTimeout(t);
        const r = el.getBoundingClientRect();
        burst(r.left + r.width / 2, r.top + r.height / 2, 40);
        FF.toast && FF.toast(pick(PEEK_SAY[season] || ['Hallo!']));
        snooze('peeker');
        hide();
      });
    };
    // 1) kurz nach dem Laden, 2) wenn Kund:innen kurz innehalten, 3) beim Scrollen über die Seitenmitte
    setTimeout(show, 4000);
    const reset = () => { clearTimeout(idle); idle = setTimeout(show, 9000); };
    ['scroll', 'pointermove', 'keydown'].forEach((ev) => window.addEventListener(ev, reset, { passive: true }));
    let half = false;
    window.addEventListener('scroll', () => {
      const p = window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (!half && p > 0.55) { half = true; setTimeout(show, 400); }
    }, { passive: true });
  }

  /* ---------- Katze im Footer (Halloween) & Pinguin (Winter) ---------- */
  const WALKERS = {
    halloween: '<svg viewBox="0 0 60 40" aria-hidden="true"><path d="M8 30q-6-10 2-18" stroke="#2b1d3d" stroke-width="3.5" fill="none" stroke-linecap="round"/><ellipse cx="26" cy="27" rx="16" ry="9" fill="#2b1d3d"/><circle cx="44" cy="20" r="8" fill="#2b1d3d"/><path d="M38 14l2-8 4 6zM46 12l4-7 1 8z" fill="#2b1d3d"/><circle cx="42" cy="19" r="1.6" fill="#8dff5a"/><circle cx="47" cy="19" r="1.6" fill="#8dff5a"/><g class="legs" stroke="#2b1d3d" stroke-width="3.5" stroke-linecap="round"><path d="M16 33v6M22 34v5M32 34v5M38 32v7"/></g></svg>',
    winter: '<svg viewBox="0 0 40 46" aria-hidden="true"><ellipse cx="20" cy="26" rx="13" ry="17" fill="#13233d"/><ellipse cx="20" cy="29" rx="8.5" ry="12" fill="#fff"/><circle cx="16" cy="17" r="2" fill="#fff"/><circle cx="24" cy="17" r="2" fill="#fff"/><circle cx="16.5" cy="17.4" r="1" fill="#13233d"/><circle cx="24.5" cy="17.4" r="1" fill="#13233d"/><path d="M17 21l3 3 3-3z" fill="#f5a623"/><path d="M8 13q12-12 24 0" fill="#e23b4a"/><circle cx="20" cy="4" r="3" fill="#fff"/><g class="legs" fill="#f5a623"><ellipse cx="14" cy="43" rx="4" ry="2"/><ellipse cx="26" cy="43" rx="4" ry="2"/></g></svg>'
  };
  function initWalker() {
    const svg = WALKERS[season];
    const footer = $('.footer');
    if (!svg || !footer || !FULL) return;
    const w = document.createElement('div');
    w.className = 'fx-walker fx-walker--' + season;
    w.innerHTML = svg;
    footer.appendChild(w);
  }

  /* ---------- Flug in den Warenkorb ----------------------------------- */
  const flyIcon = {
    halloween: '<svg viewBox="0 0 40 46" width="42" aria-hidden="true"><path d="M20 2C10 2 4 10 4 20v22l6-5 5 5 5-5 5 5 5-5 6 5V20C36 10 30 2 20 2z" fill="#f4eefc" stroke="#1a1326" stroke-width="2"/><ellipse cx="14" cy="19" rx="3" ry="4" fill="#1a1326"/><ellipse cx="26" cy="19" rx="3" ry="4" fill="#1a1326"/><ellipse cx="20" cy="29" rx="3" ry="4" fill="#1a1326"/></svg>',
    fasching: '🎉', kobold: '🍀', sommer: '☀️', winter: '🎁'
  };
  function flyToCart(source) {
    const target = $('[data-cart-open]');
    if (!source || !target) return;
    const s = source.getBoundingClientRect(), t = target.getBoundingClientRect();
    const el = document.createElement('div');
    el.className = 'fly-item';
    el.innerHTML = flyIcon[season] || '✨';
    document.body.appendChild(el);
    const x0 = s.left + s.width / 2 - 20, y0 = s.top + s.height / 2 - 20;
    const x1 = t.left + t.width / 2 - 20, y1 = t.top + t.height / 2 - 20;
    const midX = (x0 + x1) / 2 + rand(-80, 80), midY = Math.min(y0, y1) - 140;
    const anim = el.animate([
      { transform: `translate(${x0}px, ${y0}px) scale(.6) rotate(0deg)`, opacity: 0 },
      { transform: `translate(${x0}px, ${y0 - 30}px) scale(1.2) rotate(-10deg)`, opacity: 1, offset: 0.15 },
      { transform: `translate(${midX}px, ${midY}px) scale(1.1) rotate(${season === 'halloween' ? 12 : 180}deg)`, opacity: 1, offset: 0.55 },
      { transform: `translate(${x1}px, ${y1}px) scale(.3) rotate(${season === 'halloween' ? -8 : 360}deg)`, opacity: 0.2 }
    ], { duration: 900, easing: 'cubic-bezier(.45,.05,.35,1)' });
    anim.onfinish = () => {
      el.remove();
      burst(t.left + t.width / 2, t.top + t.height / 2, 18);
    };
  }

  /* ---------- Events --------------------------------------------------- */
  document.addEventListener('ff:cart-added', (e) => {
    const src = e.detail && e.detail.source;
    if (src && src.getBoundingClientRect) {
      const r = src.getBoundingClientRect();
      burst(r.left + r.width / 2, r.top + r.height / 2, 55);
      flyToCart(src);
    }
  });
  document.addEventListener('ff:celebrate', (e) => {
    const src = e.detail && e.detail.source;
    const r = src ? src.getBoundingClientRect() : { left: W / 2, top: H / 2, width: 0, height: 0 };
    burst(r.left + r.width / 2, Math.max(80, r.top + 40), 80);
  });

  // Klick auf das Logo: kleines Feuerwerk
  document.addEventListener('click', (e) => {
    const logo = e.target.closest('.header__logo .ff-emblem, .footer__brand .ff-logo-svg');
    if (!logo) return;
    const r = logo.getBoundingClientRect();
    burst(r.left + r.width / 2, r.top + r.height / 2, 30);
  });

  // Tab im Hintergrund: Animationen pausieren
  document.addEventListener('visibilitychange', () => {
    document.getAnimations && document.getAnimations().forEach((a) => {
      if (a.effect && a.effect.target && a.effect.target.closest && a.effect.target.closest('[data-hero-fx]')) {
        document.hidden ? a.pause() : a.play();
      }
    });
  });

  function init() {
    initHeroFx();
    initDropper();
    initPeeker();
    initWalker();
    if (season === 'winter' && FULL) initAmbientSnow();
    // Begrüßungs-Konfetti im Fasching (einmal pro Sitzung)
    if (season === 'fasching' && FULL) {
      let seen = false;
      try { seen = sessionStorage.getItem('ff-confetti') === '1'; sessionStorage.setItem('ff-confetti', '1'); } catch (err) { seen = false; }
      if (!seen) setTimeout(() => confettiRain(120), 600);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', () => initHeroFx());
})();
